var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trianle"},[_c('div',{staticClass:"top",class:{active:!_vm.active&&_vm.isActive}}),_c('div',{staticClass:"bottom",class:{active:_vm.active&&_vm.isActive}})])
}
var staticRenderFns = []

export { render, staticRenderFns }